import { parseSelectorPath as b } from "./highrise1615.mjs";
import { isMediaOrSupports as c } from "./highrise1049.mjs";
const h = /[A-Z]/g;
function x(e) {
  return e.replace(h, (t) => "-" + t.toLowerCase());
}
function j(e, t = "  ") {
  return typeof e == "object" && e !== null ? ` {
` + Object.entries(e).map((r) => t + `  ${x(r[0])}: ${r[1]};`).join(`
`) + `
` + t + "}" : `: ${e};`;
}
function w(e, t, r) {
  return typeof e == "function" ? e({
    context: t.context,
    props: r
  }) : e;
}
function y(e, t, r, f) {
  if (!t)
    return "";
  const o = w(t, r, f);
  if (!o)
    return "";
  if (typeof o == "string")
    return `${e} {
${o}
}`;
  const n = Object.keys(o);
  if (n.length === 0)
    return r.config.keepEmptyBlock ? e + ` {
}` : "";
  const i = e ? [
    e + " {"
  ] : [];
  return n.forEach((p) => {
    const s = o[p];
    if (p === "raw") {
      i.push(`
` + s + `
`);
      return;
    }
    p = x(p), s != null && i.push(`  ${p}${j(s)}`);
  }), e && i.push("}"), i.join(`
`);
}
function $(e, t, r) {
  e && e.forEach((f) => {
    if (Array.isArray(f))
      $(f, t, r);
    else if (typeof f == "function") {
      const o = f(t);
      Array.isArray(o) ? $(o, t, r) : o && r(o);
    } else f && r(f);
  });
}
function g(e, t, r, f, o) {
  const n = e.$;
  let i = "";
  if (!n || typeof n == "string")
    c(n) ? i = n : t.push(n);
  else if (typeof n == "function") {
    const u = n({
      context: f.context,
      props: o
    });
    c(u) ? i = u : t.push(u);
  } else if (n.before && n.before(f.context), !n.$ || typeof n.$ == "string")
    c(n.$) ? i = n.$ : t.push(n.$);
  else if (n.$) {
    const u = n.$({
      context: f.context,
      props: o
    });
    c(u) ? i = u : t.push(u);
  }
  const p = b(t), s = y(p, e.props, f, o);
  i ? r.push(`${i} {`) : s.length && r.push(s), e.children && $(e.children, {
    context: f.context,
    props: o
  }, (u) => {
    if (typeof u == "string") {
      const l = y(p, { raw: u }, f, o);
      r.push(l);
    } else
      g(u, t, r, f, o);
  }), t.pop(), i && r.push("}"), n && n.after && n.after(f.context);
}
function k(e, t, r) {
  const f = [];
  return g(e, [], f, t, r), f.join(`

`);
}
export {
  k as render
};
